import React from 'react';
import { connect } from 'react-redux';
import queryString from 'query-string';
import InvoiceHeaderForm from './InvoiceHeaderForm';
import InvoiceItemsForm from './InvoiceItemsForm';
import AddInvoiceItemForm from './AddInvoiceItemForm';
import ContainerRowSpace from '../../components/common/ContainerRowSpace'
import ContainerRowTitle from '../../components/common/ContainerRowTitle'

const renderInvoiceItemForm=(openAddInvItem,taskAcceptedInfoId,jwt)=>{
    if (openAddInvItem){
        return <AddInvoiceItemForm taskAcceptedInfoId={taskAcceptedInfoId} jwt={jwt} />
    }else {
        return <InvoiceItemsForm taskAcceptedInfoId={taskAcceptedInfoId} jwt={jwt} />
    }
}

const InvoiceDataExtractionForm = props => {
    const { projApollo,location } = props;
    const { openAddInvItem } = projApollo;
    const query = queryString.parse(location.search);
    
    if (!query.jwt || !query.pdfUrl || !query.taskAcceptedInfoId) {
        
        return (
            <div className="container">
                <ContainerRowSpace />
                <ContainerRowTitle title={'Invoice Data Extraction'}/>
                <div className="row">
                    <div className='col-sm'>
                        <div className="alert alert-danger" role="alert">
                        ERROR! Missing Parameters!
                        </div>      
                    </div>
                </div>    
            </div>
        )
    }
    const pdfUrl=query.pdfUrl
    let fileExt=pdfUrl.substring(pdfUrl.length - 4,pdfUrl.length)
    fileExt=fileExt.toLowerCase();    
    return (
        <div className="container">
            <ContainerRowSpace />
            <ContainerRowTitle title={'Invoice Data Extraction'}/>
            <div className="row">
                <div className='col-sm'>
                    <a href={'https://docs.google.com/document/d/e/2PACX-1vQm4_jWmGniFFMwwaj00PwR7HgOEgK98GMUojxIGkkYXNDtTyUzBMXpXq3B4tuyXZuiMhV71B6f5VRR/pub?embedded=true'} target='_blank' >Instructions</a>
                    &nbsp;&nbsp;&nbsp;
                    <a href={query.pdfUrl} target='_blank' >PDF/Excel Link</a>
                </div>
            </div>  
            <ContainerRowSpace />
            <div className="row">
                <div className="col-sm">
                    
                     {fileExt=='xlsx'?(
                      <div className='excelLogo'>
                            <img src='/img/microsoft_excel_icon.png'  />
                      </div>
                      ):
                      (
                        <div className="embed-responsive embed-responsive-1by1" style={{height: '100%',width: '100%'}}>
                          <iframe className="embed-responsive-item" src={query.pdfUrl}></iframe>
                        </div>
                      )}
                    
                </div>
                <div className="col-sm">
                  <InvoiceHeaderForm jwt={query.jwt} taskAcceptedInfoId={query.taskAcceptedInfoId}/>
                </div>
            </div>
            <ContainerRowSpace />
            <div className="row">
               <div className="col-sm">
                {renderInvoiceItemForm(openAddInvItem,query.taskAcceptedInfoId,query.jwt)}
                </div>
            </div>
            <ContainerRowSpace />
        </div>
    )
}

const mapStateToProps = (state, ownProps) => {
    return {
        projApollo: state.projApollo
    }
}

export default connect(mapStateToProps)(InvoiceDataExtractionForm);


// WEBPACK FOOTER //
// ./src/views/ProjectApollo/InvoiceDataExtractionForm.js